<script setup lang="ts">
import ContactBoxAvatarRating from '@/shared/components/ContactBox/ContactBoxAvatarRating.vue';
import ContactBoxActions from '@/shared/components/ContactBox/ContactBoxActions.vue';
import ContactBoxInfo from '@/shared/components/ContactBox/ContactBoxInfo.vue';
import SidebarRating from '@/shared/components/Sidebar/SidebarRating.vue';
import SidebarInternal from '@/shared/components/Sidebar/SidebarInternal.vue';
import { useAppStore } from '@/shared/stores/AppStore';
import { provide } from 'vue';

const { showInternalInformation } = useAppStore();

provide('give-rating-ga-label', 'eventLabelRatingDetail');
provide('give-rating-button', 'giveRating');

interface Props {
  isVisible?: boolean;
  linkedProfile?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  isVisible: false,
  linkedProfile: true,
});
</script>

<template>
  <aside>
    <div class="xl:border xl:border-neutral-100 xl:bg-white xl:rounded-xl xl:shadow-lg xl:overflow-hidden">
      <SidebarRating v-if="props.isVisible" />
      <ContactBoxAvatarRating v-else :linkedProfile="linkedProfile" />
      <ContactBoxActions />
      <ContactBoxInfo />
    </div>
    <SidebarInternal v-if="showInternalInformation" />
  </aside>
</template>
